import { render, staticRenderFns } from "./RedeemHome.vue?vue&type=template&id=68c4a5d3&"
import script from "./RedeemHome.vue?vue&type=script&lang=js&"
export * from "./RedeemHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports